import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, LogOut, Gavel } from "lucide-react";
import { useLang } from "@/LangContext";
import PortalAuth from "@/components/PortalAuth";
import BidderDashboard from "@/components/BidderDashboard";
import { authAxios, getToken, setToken } from "@/lib/auth";

const LANGS = ["es", "en", "fr", "pt"];

export default function BidderPortal() {
  const { t, lang, setLang } = useLang();
  const p = t.portal;
  const [bidder, setBidder] = useState(undefined);

  useEffect(() => {
    if (!getToken()) return setBidder(null);
    authAxios
      .get("/auction/me")
      .then((r) => setBidder(r.data))
      .catch(() => {
        setToken(null);
        setBidder(null);
      });
  }, []);

  const logout = () => {
    setToken(null);
    setBidder(null);
  };

  return (
    <div data-testid="bidder-portal" className="min-h-screen bg-[#0A0C10] font-body text-slate-100 antialiased">
      <div className="bg-noise" aria-hidden="true" />
      <header className="relative border-b border-white/10">
        <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-4 sm:px-6">
          <Link to="/" data-testid="portal-back-link" className="flex items-center gap-2 font-code text-xs uppercase tracking-[0.25em] text-slate-400 transition-colors hover:text-amber-400">
            <ArrowLeft size={14} /> {p.back}
          </Link>
          <div className="flex items-center gap-4">
            <div className="flex border border-white/15">
              {LANGS.map((l) => (
                <button
                  key={l}
                  data-testid={`portal-lang-${l}`}
                  onClick={() => setLang(l)}
                  className={`px-2.5 py-1.5 font-code text-[10px] uppercase tracking-[0.2em] ${lang === l ? "bg-amber-400 text-[#0A0C10]" : "text-slate-400"}`}
                >
                  {l}
                </button>
              ))}
            </div>
            {bidder && (
              <button data-testid="portal-logout" onClick={logout} className="flex items-center gap-2 font-code text-xs uppercase tracking-[0.25em] text-slate-400 transition-colors hover:text-amber-400">
                <LogOut size={14} /> {p.logout}
              </button>
            )}
          </div>
        </div>
      </header>

      <main className="relative mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="flex items-center gap-3 text-amber-400">
          <Gavel size={18} />
          <span className="font-code text-[11px] uppercase tracking-[0.35em]">{p.subtitle}</span>
        </div>
        <h1 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl lg:text-6xl">{p.title}</h1>

        <div className="mt-12">
          {bidder === undefined ? null : bidder ? (
            <BidderDashboard bidder={bidder} />
          ) : (
            <div className="mx-auto max-w-lg">
              <PortalAuth onAuth={setBidder} />
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
